/* @flow */
import * as F from 'lodash/fp';

import type { Sushi, SushiKind, SushiSubkind } from './rules/types';
import type { SushiGroupInfo, SushiMapper } from './type';
import Dish0601 from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g6-dish01@3x.png';
import Dish0602 from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g6-dish02@3x.png';
import Dish0603 from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g6-dish03@3x.png';
import Dish0604 from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g6-dish04@3x.png';
import GroupDish0601 from '../assets/images/pages/sushi/sushi/sushi_ﬁ_g6-modal-dish01@3x.png';
import GroupDish0602 from '../assets/images/pages/sushi/sushi/sushi_ﬁ_g6-modal-dish02@3x.png';
import GroupDish0603 from '../assets/images/pages/sushi/sushi/sushi_ﬁ_g6-modal-dish03@3x.png';
import GroupDish0604 from '../assets/images/pages/sushi/sushi/sushi_ﬁ_g6-modal-dish04@3x.png';
import DishGunkan from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-dish03@3x.png';
import DishMaki from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-dish04@3x.png';
import DishNigiri1 from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-dish01@3x.png';
import DishNigiri2 from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-dish02@3x.png';
import GroupIconGunkan from '../assets/images/pages/sushi/sushi/sushi_ﬁ_g3-dish-icon03@3x.png';
import GroupIconMaki from '../assets/images/pages/sushi/sushi/sushi_ﬁ_g3-dish-icon04@3x.png';
import GroupIconNigiri1 from '../assets/images/pages/sushi/sushi/sushi_ﬁ_g3-dish-icon01@3x.png';
import GroupIconNigiri2 from '../assets/images/pages/sushi/sushi/sushi_ﬁ_g3-dish-icon02@3x.png';
import IconChuutoro from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-col13@3x.png';
import IconChuutoroBw from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi13@3x.png';
import IconCorn from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-col09@3x.png';
import IconCornBw from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi09@3x.png';
import IconEbi from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-col04@3x.png';
import IconEbiBw from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi04@3x.png';
import IconIkura from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-col07@3x.png';
import IconIkuraBw from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi07@3x.png';
import IconKaisen from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-col11@3x.png';
import IconKaisenBw from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi11@3x.png';
import IconKappa from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-col10@3x.png';
import IconKappaBw from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi10@3x.png';
import IconMaguro from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-col01@3x.png';
import IconMaguroBw from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi01@3x.png';
import IconSaba from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-col03@3x.png';
import IconSabaBw from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi03@3x.png';
import IconSalmon from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-col02@3x.png';
import IconSalmonBw from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi02@3x.png';
import IconTako from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-col05@3x.png';
import IconTakoBw from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi05@3x.png';
import IconTamago from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-col06@3x.png';
import IconTamagoBw from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi06@3x.png';
import IconTemaki from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-col12@3x.png';
import IconTemakiBw from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi12@3x.png';
import IconUni from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-col08@3x.png';
import IconUniBw from '../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi08@3x.png';
import ImgChuutoro from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-sushi13@3x.png';
import ImgCorn from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-sushi09@3x.png';
import ImgEbi from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-sushi04@3x.png';
import ImgIkura from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-sushi07@3x.png';
import ImgKaisen from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-sushi11@3x.png';
import ImgKappa from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-sushi10@3x.png';
import ImgMaguro from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-sushi01@3x.png';
import ImgSaba from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-sushi03@3x.png';
import ImgSalmon from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-sushi02@3x.png';
import ImgTako from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-sushi05@3x.png';
import ImgTamago from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-sushi06@3x.png';
import ImgTemaki from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-sushi12@3x.png';
import ImgUni from '../assets/images/pages/sushi/simulation/sushi_ﬁ_g3-sushi08@3x.png';

function makeSushi(kind: SushiKind, subkind: SushiSubkind): Sushi {
  return { kind, subkind };
}

// 3rd year
const groupsThird: SushiGroupInfo[] = [
  {
    name: 'にぎり①',
    icon: GroupIconNigiri1,
    color: '#b0dbf4',
    sushi: [makeSushi(1, 1), makeSushi(1, 2), makeSushi(1, 3)],
  },
  {
    name: 'にぎり②',
    icon: GroupIconNigiri2,
    color: '#c3eee5',
    sushi: [makeSushi(2, 1), makeSushi(2, 2), makeSushi(2, 3)],
  },
  {
    name: 'ぐんかん',
    icon: GroupIconGunkan,
    color: '#ffd5e3',
    sushi: [makeSushi(3, 1), makeSushi(3, 2), makeSushi(3, 3)],
  },
  { name: 'まき物', icon: GroupIconMaki, color: '#d3d3d3', sushi: [makeSushi(4, 1), makeSushi(4, 2), makeSushi(4, 3)] },
];

const sushiGroupsThird = F.pipe(
  F.map(kind => [
    kind,
    F.pipe(
      F.map(subkind => [
        subkind,
        groupsThird.find(group => group.sushi.some(s => s.kind === kind && s.subkind === subkind)),
      ]),
      F.fromPairs
    )([1, 2, 3]),
  ]),
  F.fromPairs
)([1, 2, 3, 4]);

const namesThird = {
  '1': { '1': 'マグロ', '2': 'サーモン', '3': 'サバ' },
  '2': { '1': 'エビ', '2': 'タコ', '3': 'タマゴ' },
  '3': { '1': 'イクラ', '2': 'ウニ', '3': 'コーン' },
  '4': { '1': 'かっぱ', '2': 'かいせん', '3': 'てまき' },
};

const iconsThird = {
  '1': { '1': IconMaguro, '2': IconSalmon, '3': IconSaba },
  '2': { '1': IconEbi, '2': IconTako, '3': IconTamago },
  '3': { '1': IconIkura, '2': IconUni, '3': IconCorn },
  '4': { '1': IconKappa, '2': IconKaisen, '3': IconTemaki },
};

const bwIconsThird = {
  '1': { '1': IconMaguroBw, '2': IconSalmonBw, '3': IconSabaBw },
  '2': { '1': IconEbiBw, '2': IconTakoBw, '3': IconTamagoBw },
  '3': { '1': IconIkuraBw, '2': IconUniBw, '3': IconCornBw },
  '4': { '1': IconKappaBw, '2': IconKaisenBw, '3': IconTemakiBw },
};

const sushiImgsThird = {
  '1': { '1': ImgMaguro, '2': ImgSalmon, '3': ImgSaba },
  '2': { '1': ImgEbi, '2': ImgTako, '3': ImgTamago },
  '3': { '1': ImgIkura, '2': ImgUni, '3': ImgCorn },
  '4': { '1': ImgKappa, '2': ImgKaisen, '3': ImgTemaki },
};

const dishImgsThird = {
  '1': DishNigiri1,
  '2': DishNigiri2,
  '3': DishGunkan,
  '4': DishMaki,
};

export const thirdYearMapper: SushiMapper = {
  getSushiGroups: () => groupsThird,
  getSushiGroup: ({ kind, subkind }) => sushiGroupsThird[kind][subkind] || groupsThird[0],
  getSushiName: ({ kind, subkind }) => namesThird[kind][subkind],
  getSushiIcon: ({ kind, subkind }) => iconsThird[kind][subkind],
  getSushiBwIcon: ({ kind, subkind }) => bwIconsThird[kind][subkind],
  getSushiPrice: _sushi => 100,
  getSushiOriginalPrice: _sushi => 0,
  getSushiImg: ({ kind, subkind }) => sushiImgsThird[kind][subkind],
  getSushiDishImg: ({ kind }) => dishImgsThird[kind],
  getExitLink: () => '/sushi/fields',
  getTitle: () => '売れるおすしを考えよう',
};

// sixth grade
const groupsSixth: SushiGroupInfo[] = [
  {
    name: '100円',
    icon: GroupDish0601,
    color: '#ffd5e3',
    sushi: [makeSushi(1, 1), makeSushi(2, 2), makeSushi(3, 3)],
  },
  {
    name: '130円',
    icon: GroupDish0602,
    color: '#b0dbf4',
    sushi: [makeSushi(1, 2), makeSushi(2, 3), makeSushi(4, 1)],
  },
  {
    name: '170円',
    icon: GroupDish0603,
    color: '#c3eee5',
    sushi: [makeSushi(1, 3), makeSushi(3, 1), makeSushi(4, 2)],
  },
  { name: '200円', icon: GroupDish0604, color: '#d3d3d3', sushi: [makeSushi(2, 1), makeSushi(3, 2), makeSushi(4, 3)] },
];

const sushiGroupsSixth = F.pipe(
  F.map(kind => [
    kind,
    F.pipe(
      F.map(subkind => [
        subkind,
        groupsSixth.find(group => group.sushi.some(s => s.kind === kind && s.subkind === subkind)),
      ]),
      F.fromPairs
    )([1, 2, 3]),
  ]),
  F.fromPairs
)([1, 2, 3, 4]);

const namesSixth = {
  '1': { '1': 'サーモン', '2': 'サバ', '3': 'トロ' },
  '2': { '1': 'エビ', '2': 'タコ', '3': 'タマゴ' },
  '3': { '1': 'イクラ', '2': 'ウニ', '3': 'コーン' },
  '4': { '1': 'かっぱ', '2': 'かいせん', '3': 'てまき' },
};

const iconsSixth = {
  '1': { '1': IconSalmon, '2': IconSaba, '3': IconChuutoro },
  '2': { '1': IconEbi, '2': IconTako, '3': IconTamago },
  '3': { '1': IconIkura, '2': IconUni, '3': IconCorn },
  '4': { '1': IconKappa, '2': IconKaisen, '3': IconTemaki },
};

const bwIconsSixth = {
  '1': { '1': IconSalmonBw, '2': IconSabaBw, '3': IconChuutoroBw },
  '2': { '1': IconEbiBw, '2': IconTakoBw, '3': IconTamagoBw },
  '3': { '1': IconIkuraBw, '2': IconUniBw, '3': IconCornBw },
  '4': { '1': IconKappaBw, '2': IconKaisenBw, '3': IconTemakiBw },
};

const sushiImgsSixth = {
  '1': { '1': ImgSalmon, '2': ImgSaba, '3': ImgChuutoro },
  '2': { '1': ImgEbi, '2': ImgTako, '3': ImgTamago },
  '3': { '1': ImgIkura, '2': ImgUni, '3': ImgCorn },
  '4': { '1': ImgKappa, '2': ImgKaisen, '3': ImgTemaki },
};

const dishImgsSixth = {
  '1': Dish0601,
  '2': Dish0602,
  '3': Dish0603,
  '4': Dish0604,
};

const sushiDishGroupsSixth = F.pipe(
  F.map(kind => [
    kind,
    F.pipe(
      F.map(subkind => {
        let i = 0;
        for (i = 0; i < groupsSixth.length; i++) {
          const group = groupsSixth[i];
          if (group.sushi.some(s => s.kind === kind && s.subkind === subkind)) break;
        }
        return [subkind, dishImgsSixth[i + 1]];
      }),
      F.fromPairs
    )([1, 2, 3]),
  ]),
  F.fromPairs
)([1, 2, 3, 4]);

const sushiPricesSixth = {
  '1': { '1': 100, '2': 130, '3': 170 },
  '2': { '1': 200, '2': 100, '3': 130 },
  '3': { '1': 170, '2': 200, '3': 100 },
  '4': { '1': 130, '2': 170, '3': 200 },
};

const sushiOriginalPricesSixth = {
  '1': { '1': 30, '2': 40, '3': 60 },
  '2': { '1': 70, '2': 30, '3': 40 },
  '3': { '1': 60, '2': 70, '3': 30 },
  '4': { '1': 40, '2': 60, '3': 70 },
};

export const sixthYearMapper: SushiMapper = {
  getSushiGroups: () => groupsSixth,
  getSushiGroup: ({ kind, subkind }) => sushiGroupsSixth[kind][subkind] || groupsSixth[0],
  getSushiName: ({ kind, subkind }) => namesSixth[kind][subkind],
  getSushiIcon: ({ kind, subkind }) => iconsSixth[kind][subkind],
  getSushiBwIcon: ({ kind, subkind }) => bwIconsSixth[kind][subkind],
  getSushiPrice: ({ kind, subkind }) => sushiPricesSixth[kind][subkind],
  getSushiOriginalPrice: ({ kind, subkind }) => sushiOriginalPricesSixth[kind][subkind],
  getSushiImg: ({ kind, subkind }) => sushiImgsSixth[kind][subkind],
  getSushiDishImg: ({ kind, subkind }) => sushiDishGroupsSixth[kind][subkind],
  getExitLink: () => '/sushi-a/fields',
  getTitle: () => '売れるおすしを予想しよう',
};
